/* eslint-disable no-nested-ternary */
import { CircularProgress } from '@ouster/webviz-react-components';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import EulaViewer from '../../components/auth/EulaViewer';
import Stepper from '../../components/auth/Stepper';
import UserLocation from '../../components/auth/UserLocation';
import { useKeycloak } from '../../KeycloakContext';
import { NavBackButton } from '../../layouts/AuthLayout';
import styles from '../PublicPage.module.css';

export default function SignUpPage() {
  const { keycloak } = useKeycloak();

  const navigate = useNavigate();

  const [isEulaAccepted, setIsEulaAccepted] = useState(false);
  const [isLocationCollected, setIsLocationCollected] = useState(false);

  const updateUserLocation = (country: string, state: string) => {
    sessionStorage.setItem('country', country);
    sessionStorage.setItem('state', state);
    setIsLocationCollected(true);
  };

  const getStepContent = () => {
    if (isEulaAccepted) {
      return {
        step: 3,
        content: (
          <div className={styles['loading-container']}>
            <CircularProgress isIndeterminate size="50px" thickness={10} />
          </div>
        ),
      };
    }

    if (isLocationCollected) {
      return {
        step: 2,
        content: (
          <EulaViewer
            setIsEulaVisible={setIsLocationCollected} // when user rejects EULA, we set isLocationCollected to false
            setIsEulaAccepted={setIsEulaAccepted}
          />
        ),
      };
    }

    // starting point
    return {
      step: 1,
      content: <UserLocation updateUserLocation={updateUserLocation} />,
    };
  };

  const { step: curStep, content } = getStepContent();

  useEffect(() => {
    /* 
      For some reason, when user dropped in middle of the registration and they try to resume.
      we will try to fetch the data if existed and skip asking same questions again
    */
    const encodedData = localStorage.getItem('registrationData');
    if (encodedData && keycloak?.authenticated) {
      try {
        const registrationData = JSON.parse(atob(encodedData)) as {
          country?: string;
          state?: string;
          eulaVersion?: string;
          eulaAccepted?: boolean;
        };
        const { country, eulaVersion, eulaAccepted } = registrationData;
        if (country && eulaVersion && eulaAccepted) {
          navigate('/post-registration');
        }
      } catch (err) {
        // If parsing fails, ignore and continue normal flow
      }
    }
  }, [keycloak, navigate]);

  useEffect(() => {
    if (isEulaAccepted) {
      if (keycloak) {
        const country = sessionStorage.getItem('country') || '';
        const state = sessionStorage.getItem('state') || '';
        const eulaVersion = sessionStorage.getItem('eula-version') || '';

        // Create the registration data object
        const registrationData = {
          country,
          state,
          eulaVersion,
          eulaAccepted: true,
        };

        // Base64 encode the data
        const encodedData = btoa(JSON.stringify(registrationData));

        // Save encoded data to localStorage
        localStorage.setItem('registrationData', encodedData);

        if (keycloak.authenticated) {
          navigate('/post-registration');
        } else {
          const returnUrl = `${window.location.origin}/post-registration`;
          keycloak.register({
            redirectUri: returnUrl,
          });
        }
      }
    }
  }, [isEulaAccepted, keycloak, navigate]);

  if (!keycloak)
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
      </div>
    );

  return (
    <div className={styles['auth-container']}>
      {/* back button */}
      <div className={styles['left-panel']}>{/* <NavBackButton /> */}</div>
      {/* stepper - showing current stage */}
      <Stepper prevStep={0} currentStep={curStep} totalSteps={3} />
      {/* login page content */}
      <section className={styles['auth-section']}>
        <div className={styles['mobile-back-button']}>
          <NavBackButton />
        </div>
        {content}
      </section>
    </div>
  );
}
